import { render, staticRenderFns } from "./ViewFarmerDetails.vue?vue&type=template&id=3585a7c2&"
import script from "./ViewFarmerDetails.vue?vue&type=script&lang=js&"
export * from "./ViewFarmerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports